import { useMutation, useQueryClient } from 'react-query';
import { BuildingService } from '../../services/buildingService';
import v1Messages from '../ManageBuildings/messages';

export const buildingsQueryKey = (
  organizationId: ?string,
  propertyId: ?string,
) => ['buildings', organizationId, propertyId];

const useUpdateBuilding = ({
  organizationId,
  propertyId,
  promptToaster,
  intl,
}: {
  organizationId: ?string,
  propertyId: ?string,
  promptToaster: Function,
  intl: Object,
}) => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ id, payload }) =>
      new BuildingService().update(organizationId, propertyId, id, payload),
    {
      onSuccess: (data, { id, fractionsChanged }) => {
        promptToaster({
          title: intl.formatMessage(v1Messages.success),
          message: intl.formatMessage(v1Messages.successBody),
        });
        queryClient.invalidateQueries(
          buildingsQueryKey(organizationId, propertyId),
        );
        if (fractionsChanged) {
          queryClient.invalidateQueries([
            'naur-property-compliance-details',
            propertyId,
          ]);
          queryClient.invalidateQueries(['naurEvents', 'building', id]);
        }
      },
      onError: (error, { id, fractionsChanged }) => {
        const errorName =
          typeof error === 'string' ? error : error?.message ?? '';
        const isNaurRefusal = errorName.includes('unresolved NAUR events');
        promptToaster({
          type: 'error',
          title: intl.formatMessage(v1Messages.error),
          message: intl.formatMessage(
            isNaurRefusal
              ? v1Messages.errorApplicableFractionNaurApi
              : v1Messages[errorName] ?? v1Messages.errorBody,
          ),
        });
        // The API answers a NAUR refusal with a generic 500 today, so any failed fraction save
        // refetches the building's NAUR events; the open form then locks the fractions.
        if (isNaurRefusal || fractionsChanged) {
          queryClient.invalidateQueries(['naurEvents', 'building', id]);
        }
      },
    },
  );
};

export default useUpdateBuilding;
